module.exports = __webpack_public_path__ + "static/media/IMAGE-RWE.ade6312c.png";